import { useChat } from "@eworkit/messenger";
import { useQuery } from "react-query";

import { useFeatureFlags } from "@/components/FeatureFlags";
import { FEATURE_FLAG } from "@/data/feature-flags";

type EntityType = "JOB_REQUEST_APPLICATION";

const createUseConversation = (entityType: EntityType) => (entityId: number) => {
  const { findConversationId } = useChat();
  const { isFeatureEnabled } = useFeatureFlags();

  const queryResults = useQuery(["chat", entityType, entityId], () => findConversationId(entityType, entityId), {
    enabled: isFeatureEnabled(FEATURE_FLAG.MESSAGE_CENTER),
  });

  return {
    ...queryResults,
    conversationId: queryResults.data,
  };
};

export const useApplicationConversation = createUseConversation("JOB_REQUEST_APPLICATION");
